import BehaviorConfig from '@/models/app-config/behavior/behavior'

export function buildAllowedMailDomain(behaviorConfig: BehaviorConfig): string {
  if (behaviorConfig.isMyColor) {
    return '@mycolor.jp'
  }
  if (behaviorConfig.isFitowa) {
    return '「@fitowa.jp」「@fitowa.net」'
  }
  if (behaviorConfig.isVilb) {
    return '@vilb.jp'
  }
  if (behaviorConfig.isHotellovers) {
    return '@hotellovers.jp'
  }

  return ''
}
